import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { cartState } from "../../NambaStore/state/cartState";
import "./SuccessPage.scss";
import combinedServices from "../../../shared/services/user-service";
import CryptoJS from "crypto-js";
import Header from "../../../Components/Layout/Header/Header";
import Footer from "../../../Components/Layout/Footer/Footer";
import userConstants from "../../../shared/constants/user-constants";
import getLocalData from "../../../shared/localStorage/getData";
import { io } from "socket.io-client";
import { useMemo } from "react";

const PosSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setCartState = useSetRecoilState(cartState);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [tranctationId, setTranctationId] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [payerId, setPayerID] = useState("");

  const socket = useMemo(() => io.connect(userConstants.baseURL), []);

  const triggerPOSpaymentSuccess = (data) => {
    socket.emit("POSpayment", data);
  };

  useEffect(() => {
    let userEmailId = "";
    if (getLocalData("user_info", "isLogin")) {
      userEmailId = getLocalData("user_info", "all").userData.login_user_detail
        .data.user.user_email;
    }

    const capturePayment = async () => {
      const searchParams = new URLSearchParams(location.search);
      const orderid = searchParams.get("orderId");
      const token = searchParams.get("token");
      const PayerID = searchParams.get("PayerID");
      setPayerID(PayerID);

      if (!token || !PayerID) {
        console.error("Missing token or PayerID.");
        setPaymentStatus("failed");
        setIsLoading(false);
        return;
      }

      try {
        const response = await combinedServices.Poscapturepayment(
          token,
          PayerID,
          orderid
        );
          console.log("Payment captured successfully:", response.data);

        if (response && response.data && response.data.status === 200) {
          console.log("Payment captured successfully:", response.data);
          setPaymentId(response.data.data.id);
          setTranctationId(
            response.data.data.purchase_units[0].payments.captures[0].id
          );
          setPaymentStatus("success");
          
          // Emit socket event for successful payment
          triggerPOSpaymentSuccess({
            orderId: orderid,
            paymentId: response.data.data.id,
            transactionId: response.data.data.purchase_units[0].payments.captures[0].id,
            status: "success"
          });
          
          setCartState([]);
        } else {
          console.error("No payment details found or payment failed.");
          setPaymentStatus("failed");
        }
      } catch (error) {
        console.error("Error capturing payment:", error);
        setPaymentStatus("failed");
      } finally {
        setIsLoading(false);
      }
    };

    capturePayment();
  }, [location.search, setCartState]);

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <>
      <Header />
      <div className="success-page">
        <div className="success-container">
          {isLoading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>
                Processing your payment. Please do not go back or exit this
                window.
              </p>
            </div>
          ) : (
            <>
              <div className="icon-container">
                {paymentStatus === "success" ? (
                  <span className="check-icon success">✔</span>
                ) : (
                  <span className="check-icon failed">✘</span>
                )}
              </div>
              {paymentStatus === "success" ? (
                <>
                  <h1>Payment Successful!</h1>
                  <p>
                    Thank you for your purchase. Your order has been
                    successfully processed.
                  </p>
                  <div className="order-confirmation">
                    <p>We hope to see you again!</p>
                  </div>
                </>
              ) : (
                <>
                  <h1>Payment Failed</h1>
                  <p>
                    Unfortunately, your payment could not be processed. Please
                    try again.
                  </p>
                </>
              )}
              <div className="button-group">
                {paymentStatus === "success" ? (
                  <>
                    {/* <button
                      className="btn btn-primary"
                      onClick={handleViewOrders}
                    >
                      View Orders
                    </button> */}
                    <button
                      className="btn btn-secondary"
                      onClick={handleGoHome}
                    >
                      Go to Home
                    </button>
                  </>
                ) : (
                  <button className="btn btn-secondary" onClick={handleGoHome}>
                    Go to Home
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PosSuccessPage;
